import {UseQueryOptions, useQuery} from '@tanstack/react-query'
import {useExp1ProductsApiMethod} from 'api/useExp1ProductsApiMethod'
import {keyBy} from 'lodash'
import {useMemo} from 'react'
import {Exp1, Ventrata} from 'types'

const useGetExp1ProductsQuery = (
  productIds: string[],
  options?: Omit<UseQueryOptions<Exp1.Response>, 'queryKey' | 'queryFn'>
) => {
  const getProducts = useExp1ProductsApiMethod()

  return useQuery({
    queryKey: ['getProducts', productIds],
    queryFn: () => getProducts(productIds),
    ...options,
  })
}

export const useExp1ProductMap = (order: Ventrata.Order | null) => {
  const query = useGetExp1ProductsQuery(order?.bookings.map((booking) => booking.product.id) || [])

  return useMemo(() => {
    return keyBy(query.data?.tours, 'product_id')
  }, [query.data])
}
